module.exports = __webpack_public_path__ + "static/media/Metropolia-300x136.1379412e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/clients/Metropolia-300x136.png
// module id = 303
// module chunks = 0